import React, { useState, useEffect } from "react";
import axios from "axios";
import * as Yup from "yup";

import { Field, Form, Formik } from "formik";
import TimePicker from "rc-time-picker";
import { useParams, useNavigate, Link } from "react-router-dom";
import Select from "react-select";
import { uploadAWS } from "../../../common/AWSHelper";
import Loader from "../../../components/Loader/Loader";
import moment from "moment";
import { toastError, toastSuccess } from "../../../common/Toast";
import {
  ALREADY_EXIST,
  AWS_IMAGE_FOLDER_LOCATIONS,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../../common/Constant";
import config from "../../../config/config";
import { Time } from "../../../common/imagePath";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import FileInput from "../../../components/FormControls/FileInput";
import LocationsTableRows from "./LocationsTableRows";
import LocationField from "./LocationField";
import LocationWorldpay from "./LocationWorldpay";
import LocationCardConnect from "./LocationCardconnect";
import LocationStripe from "./LocationStripe";
import LocationSquare from "./LocationSquare";
import LocationBraintree from "./LocationBraintree";
import TimezoneSelect from "react-timezone-select";
// import AilseRow from "./AisleRows";
// import RackRow from "./RackRows";
// import ShelfRow from "./ShelfRows";
// import BinRow from "./BinRows";
// import { IoMdAddCircle } from "react-icons/io";

const ManageLocations = (props) => {
  let navigate = useNavigate();
  const paramObject = useParams();

  const token = localStorage.getItem("Token");
  const Id = localStorage.getItem("ID");

  const [customFields, setCustomFields] = useState([]);
  const [FormValue , setFormValue] = useState()

  console.log(FormValue , "FormValue------>")

  // const [aisleRows, setAisleRows] = useState([]);
  // const [binRows, setBinRows] = useState([]);
  // const [rackRows, setRackRows] = useState([]);
  // const [shelfRows, setShelfRows] = useState([]);

  const [rowsData, setRowsData] = useState([
    {
      RegisterId: 0,
      RegisterName: "",
      TerminalID: "",
      EnableTips: false,
    },
  ]);
  // const sendData = (data) => {
  //   setRowsData(data);
  // };
  const [worldPay, setworldPay] = useState([
    {
      RegisterId: 0,
      RegisterName: "",
      TerminalID: "",
      EnableTips: false,
      IPTranDeviceID: "",
      PinPadIP: "",
      PinPadPort: "",
    },
  ]);
  const [cardConnect, setcardConnect] = useState([
    {
      RegisterId: 0,
      RegisterName: "",
      CardConnectHSN: "",
      EnableTips: false,
    },
  ]);

  const [showColumns, setShowColumns] = useState({
    // RegisterName: false,
    // TerminalID: false,
    // EnableTips: false,
    // IPTranDeviceID: false,
    // PinPadIP: false,
    // PinPadPort: false,
    // CardReaderActions: false,
    // CardConnectHSN: false,
    // Delete: false,
    RegisterName: true,
    CardConnectHSN: true,
    TerminalID: false,
    EnableTips: true,
    IPTranDeviceID: false,
    PinPadIP: false,
    PinPadPort: false,
    CardReaderActions: false,
    Delete: true,
  });

  const [formValues, setFormValues] = useState({
    Name: "",
    CompanyName: "",
    Color: "",
    TaxID: 0,
    CompanyLogo: "",
    Deletelogo: false,
    Website: "",
    PhoneNumber: "",
    Address: "",
    Fax: "",
    Email: "",
    CCEmail: "",
    BCCEmail: "",
    Allsalestoemail: "",
    Allreceivingemail: "",
    ReturnPolicy: "",
    Employees: "",
    EnableCreditCard: false,
    CreditCardProcessor: "",
    PHPPOSPayments: "",
    DisableAmountConfirmation: false,
    PHPPOSPaymentsAPIKey: "",
    UseIntegratedEBT: false,
    PHPPOSBearerToken: "",
    PHPPOSSigningKey: "",
    PromptForLoyalty: false,
    PromptForName: false,
    PromptForEmail: false,
    PromptForPhone: false,
    TermsConditions: "",
    AskForMissingInformation: false,
    PreworkorderAuthorizationTerms: "",
    PostWorkOrderTerms: "",
    Phppostestmode: false,
    EMVmerchantid: "",
    COMPort: "",
    ListenerPort: "",
    Integratedgiftcards: false,
    Netepayserver: "",
    emvdevice: "",
    nonemvdevice: "",
    Hostedcheckout: "",
    Mercurypassword: "",
    merchantid: "",
    Restusername: "",
    Restpassword: "",
    Currencycode: "",
    Multipliercents: "",
    StripeCurrencycode: "",
    Stripesecretkey: "",
    Stripepublishablekey: "",
    BraintreeMerchantid: "",
    Publickey: "",
    Privatekey: "",
    autoemail: "",
    disablemarkup: false,
    autoemailreportstime: "",
    Daytoemailreport: "",
    ReceiveStockAlerts: false,
    Stockalertemail: "",
    Reorderlevel: "",
    Timezone: "",
    Mailchip: "",
    Platformapikey: "",
    PlatformlyProjectId: "",
    TwilioSid: "",
    TwilioToken: "",
    TwilioSms: "",
    SidekickAPIKey: "",
    SidekickAutomatically: false,
    OverrideDefaultTaxForSale: false,
    TaxGroup: "",
    TaxId1: 0,
    TaxName1: "",
    TaxPercent1: "",
    TaxId2: 0,
    TaxName2: "",
    TaxPercent2: "",
    Cumulative: false,
    TaxId3: 0,
    TaxName3: "",
    TaxPercent3: "",
    TaxId4: 0,
    TaxName4: "",
    TaxPercent4: "",
    TaxId5: 0,
    TaxName5: "",
    TaxPercent5: "",
    AdditionalAppointment: "",
  });

  const addTableRows = () => {
    const rowsInput = {
      RegisterId: 0,
      RegisterName: "",
      TerminalID: "",
      EnableTips: false,
    };
    setRowsData([...rowsData, rowsInput]);
  };

  const addTableworldPay = () => {
    const worldPayInput = {
      RegisterId: 0,
      RegisterName: "",
      TerminalID: "",
      EnableTips: false,
      IPTranDeviceID: "",
      PinPadIP: "",
      PinPadPort: "",
    };
    setworldPay([...worldPay, worldPayInput]);
  };
  const addTablecardConnect = () => {
    const cardConnectInput = {
      RegisterId: 0,
      RegisterName: "",
      CardConnectHSN: "",
      EnableTips: false,
    };
    setcardConnect([...cardConnect, cardConnectInput]);
  };

  const handleChangeTableRow = (index, evnt) => {
    console.log("evnt.target =>", evnt.target);
    const { name, value } = evnt.target;
    const rowsInput = [...rowsData];

    if (rowsInput.length > index) {
      // rowsInput[index][name] = value;
      const updatedRow = { ...rowsInput[index], [name]: value };
      rowsInput.splice(index, 1, updatedRow);
      setRowsData(rowsInput);
    } else {
      const rowobj = {
        RegisterId: 0,
        RegisterName: "",
        TerminalID: "",
        EnableTips: false,
      };
      rowobj[name] = value;
      // rowobj[name] = type === "checkbox" ? checked : value;
      setRowsData([...rowsInput, rowobj]);
    }
    // rowsInput[index][name] = value;
    console.log("rowsInput =>", rowsData);
  };

  const deleteTableRows = (deleteIndex) => {
    console.log("deleteIndex", deleteIndex);
    const updatedRowsData = rowsData.filter(
      (row, index) => index !== deleteIndex
    );

    console.log("updatedRowsData =>", updatedRowsData);

    setRowsData(updatedRowsData);
    console.log("updatedRowsData rowsDataBind=>", updatedRowsData);
  };

  const handleChangeTableworldPay = (index, evnt) => {
    console.log("pay", evnt.target);
    const { name, value } = evnt.target;
    const worldPayInput = [...worldPay];

    console.log("pay index =>", index);
    console.log("pay worldPayInput.length =>", worldPayInput.length);

    if (worldPayInput.length > index) {
      console.log("pay name =>", name);
      console.log("pay value =>", value);

      worldPayInput[index][name] = value;
      console.log("pay worldPayInput =>", worldPayInput);
    } else {
      const worldobj = {
        RegisterId: 0,
        RegisterName: "",
        TerminalID: "",
        EnableTips: false,
        IPTranDeviceID: "",
        PinPadIP: "",
        PinPadPort: "",
      };
      worldobj[name] = value;
      setworldPay([...worldPayInput, worldobj]);
    }
  };

  const deleteTableworldPay = (index) => {
    console.log(index);
    const rows = [...worldPay];
    console.log(rows);
    rows.splice(index, 1);
    console.log(rows);
    setworldPay(rows);
  };

  const handleChangeTablecardConnect = (index, evnt) => {
    console.log("card", evnt.target);
    const { name, value } = evnt.target;
    const cardConnectInput = [...cardConnect];
    cardConnectInput[index][name] = value;
    setcardConnect(cardConnectInput);
  };

  const deleteTablecardConnect = (index) => {
    console.log(index);
    const rows = [...cardConnect];
    console.log(rows);
    rows.splice(index, 1);
    console.log(rows);
    setcardConnect(rows);
  };

  const handleDropdownChange = (event) => {
    const selectedValue = event.target.value;
    setSelectCredit(event.target.value);
    console.log(event.target.value);
    // console.log("selectCredit==>",selectCredit);
    showRegisterColumns(selectedValue);
  };

  function showRegisterColumns(selectedValue) {
    if (
      selectedValue == 1 ||
      selectedValue == 4 ||
      selectedValue == 9 ||
      selectedValue == 10
    ) {
      setShowColumns({
        RegisterName: true,
        TerminalID: true,
        EnableTips: true,
        IPTranDeviceID: false,
        PinPadIP: false,
        PinPadPort: false,
        CardReaderActions: false,
        CardConnectHSN: false,
        Delete: true,
      });
    } else if (
      selectedValue == 2 ||
      selectedValue == 5 ||
      selectedValue == 6 ||
      selectedValue == 7 ||
      selectedValue == 8 ||
      selectedValue == 11
    ) {
      setShowColumns({
        RegisterName: true,
        TerminalID: true,
        EnableTips: true,
        IPTranDeviceID: true,
        PinPadIP: true,
        PinPadPort: true,
        CardReaderActions: true,
        CardConnectHSN: false,
        Delete: true,
      });
    } else {
      setShowColumns({
        RegisterName: true,
        CardConnectHSN: true,
        TerminalID: false,
        EnableTips: true,
        IPTranDeviceID: false,
        PinPadIP: false,
        PinPadPort: false,
        CardReaderActions: false,
        Delete: true,
      });
    }
  }

  const showValue = () => {
    console.log("selectCredit: ", selectCredit);
  };

  const [loading, setLoading] = useState(false);
  const [selectReceivestock, setSelectReceivestock] = useState(false);
  const [selectCreditCard, setSelectCreditCard] = useState(false);
  const [selectOverrideDefaultTaxForSale, setSelectOverrideDefaultTaxForSale] =
    useState(false);
  const [showMore, setShowMore] = useState(false);
  const [disableCumulative, setDisableCumulative] = useState(false);
  const [selectTaxable, setSelectTaxable] = useState(true);
  const [selectedTaxGroup, setSelectedTaxGroup] = useState(0);
  const [btnLoader, setBtnLoader] = useState({ companylogo: false });
  const [selectCustomCheckBox, setSelectCustomCheckBox] = useState(false);
  const [changeImagename, setChangeImagename] = useState(false);
  const [ImageUrl, setImageUrl] = useState("");
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedcreditcard, setSelectedCreditcard] = useState([]);
  const [selectCredit, setSelectCredit] = useState(1);
  // const [timezone, setTimeZone] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [selectedemployee, setselectedemployee] = useState([]);
  const [allowedToLoginEndTime, setAllowedToLoginEndTime] = useState(moment());
  const [selectedTimezone, setSelectedTimezone] = useState([]);

  const validationSchema = Yup.object().shape({
    Name: Yup.string().required(" Name is required"),
    PhoneNumber: Yup.number().required("Phone Number is required"),
    Address: Yup.string().required("Address  is required"),
  });

  const terms = [{ label: "None", value: 0 }];

  const handleSelectOverrideDefaultTaxForSale = () => {
    setSelectOverrideDefaultTaxForSale(!selectOverrideDefaultTaxForSale);
  };

  const handleSelectReceiveStocksalerts = () => {
    setSelectReceivestock(!selectReceivestock);
  };
  const handleSelectEnableCreditCardProcess = () => {
    setSelectCreditCard(!selectCreditCard);
  };

  const handleSelectTaxable = () => {
    setSelectTaxable(!selectTaxable);
  };

  // const onChangeAllowedToLoginEndTime = (e) => {
  //   setAllowedToLoginEndTime(moment(e));
  // };
  const onChangeAllowedToLoginEndTime = (e) => {
    if (e === null) {
      // reset allowedToLoginEndTime to default value
      setAllowedToLoginEndTime(moment("00:00", "HH:mm"));
    } else {
      setAllowedToLoginEndTime(moment(e));
    }
  };
  const handleShowMore = () => {
    setShowMore(!showMore);
    setDisableCumulative(true);
  };

  const handleSelectCustomCheckBox = () => {
    console.log("Checked");
    setSelectCustomCheckBox(!selectCustomCheckBox);
    console.log(selectCustomCheckBox);
  };

  // const timezoneLabel = (event) => {
  //   setSelectedTimezone(event.target.timezone.label);
  //   console.log(selectedTimezone);
  // };

  const _handleFileChange = (e) => {
    setChangeImagename(true);

    if (vaidation(e.target.name, e?.currentTarget?.files[0])) {
      uploadFile(e?.currentTarget?.files[0], e.target.name);
    }
  };

  const handleEmployeeIds = (e) => {
    setselectedemployee(Array.isArray(e) ? e.map((x) => x.value) : []);
  };

  let employeeOption = [];
  const Employees = employeeData.map((u, i) => {
    employeeOption[i] = { label: u.Name, value: u.Id };
  });

  const vaidation = (name, value) => {
    switch (name) {
      case "companylogo":
        if (!value.name.match(/\.(jpg|jpeg|png|gif|mp4)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };

  const uploadFile = async (file, type) => {
    setBtnLoader({ [type]: true });
    setLoading(true);

    await uploadAWS(file, AWS_IMAGE_FOLDER_LOCATIONS, (data) => {
      if (data) {
        if (type === "companylogo") {
          setImageUrl(data);
          setLoading(false);
        }
      }
    });
  };

  // const selectStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //   }), // dropdown input css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
  //     position: "absolute",
  //     background: "#f8f8f8",
  //     width: "100%",
  //     zIndex: 99,
  //   }), // dropdown menu css
  // };

  // Add Row of Aisle
  // const addAislerows = () => {
  //   setAisleRows([
  //     ...aisleRows,
  //     {
  //       AisleId: 0,
  //       AisleName: "",
  //     },
  //   ]);
  // };

  // Add Row of Bin
  // const addBinrows = () => {
  //   setBinRows([
  //     ...binRows,
  //     {
  //       BinId: 0,
  //       BinName: "",
  //     },
  //   ]);
  // };

  // Add Row of Shelf
  // const addShelfrows = () => {
  //   setShelfRows([
  //     ...shelfRows,
  //     {
  //       ShelfId: 0,
  //       ShelfName: "",
  //     },
  //   ]);
  // };

  // Add Row of Rack
  // const addRackerows = () => {
  //   setRackRows([
  //     ...rackRows,
  //     {
  //       RackId: 0,
  //       RackName: "",
  //     },
  //   ]);
  // };

  // HandleChanges of Aisle
  // const handleChangeAisleRow = (index, event) => {
  //   console.log(event.target.value);
  //   console.log(event.target.name);

  //   let name, values;
  //   name = event.target.name;
  //   values = event.target.value;
  //   const rowsInput = [...aisleRows];
  //   rowsInput[index][name] = values;

  //   console.log(rowsInput);

  //   setAisleRows(rowsInput);
  // };

  // HandleChanges of Bin
  // const handleChangeBinRow = (index, event) => {
  //   console.log(event.target.value);
  //   console.log(event.target.name);

  //   let name, values;
  //   name = event.target.name;
  //   values = event.target.value;
  //   const rowsInput = [...binRows];
  //   rowsInput[index][name] = values;

  //   console.log(rowsInput);

  //   setBinRows(rowsInput);
  // };

  // HandleChanges of Shelf
  // const handleChangeShelfRow = (index, event) => {
  //   console.log(event.target.value);
  //   console.log(event.target.name);

  //   let name, values;
  //   name = event.target.name;
  //   values = event.target.value;
  //   const rowsInput = [...shelfRows];
  //   rowsInput[index][name] = values;

  //   console.log(rowsInput);

  //   setShelfRows(rowsInput);
  // };

  // HandleChanges of Rack
  // const handleChangeRackRow = (index, event) => {
  //   console.log(event.target.value);
  //   console.log(event.target.name);

  //   let name, values;
  //   name = event.target.name;
  //   values = event.target.value;
  //   const rowsInput = [...rackRows];
  //   rowsInput[index][name] = values;

  //   console.log(rowsInput);

  //   setRackRows(rowsInput);
  // };

  //delete Aisle
  // const deleteAisle = (index) => {
  //   // console.log(quantity);
  //   const rows = [...aisleRows];
  //   rows.splice(index, 1);
  //   setAisleRows(rows);
  // };

  //delete Bin
  // const deleteBin = (index) => {
  //   // console.log(quantity);
  //   const rows = [...binRows];
  //   rows.splice(index, 1);
  //   setBinRows(rows);
  // };

  //delete Rack
  // const deleteRack = (index) => {
  //   // console.log(quantity);
  //   const rows = [...rackRows];
  //   rows.splice(index, 1);
  //   setRackRows(rows);
  // };

  //delete Shelf
  // const deleteShelf = (index) => {
  //   // console.log(quantity);
  //   const rows = [...shelfRows];
  //   rows.splice(index, 1);
  //   setShelfRows(rows);
  // };

  const handleSubmit = (values) => {
    //for Aisle Json
    // let LoactionAisledata = aisleRows.filter(function (aisleRows) {
    //   return aisleRows.AisleName != "";
    // })
    // const LoactionAisleobject = {};
    // LoactionAisleobject.AisleXml = LoactionAisledata;
    // let Aislejsonstring = '';
    // Aislejsonstring = JSON.stringify(LoactionAisleobject);
    // console.log("Aislejsonstring==>>", Aislejsonstring);
    // console.log("LoactionAisleobject==>>>", LoactionAisleobject);

    // //for Bin Json
    // let LoactionBindata = binRows.filter(function (binRows) {
    //   return binRows.BinName != "";
    // })
    // const LoactionBinobject = {};
    // LoactionBinobject.BinXml = LoactionBindata;
    // let Binjsonstring = '';
    // Binjsonstring = JSON.stringify(LoactionBinobject);
    // console.log("Binjsonstring==>>", Binjsonstring);
    // console.log("LoactionBinobject==>>>", LoactionBinobject);

    // //for Shelf Json
    // let LoactionShelfdata = shelfRows.filter(function (shelfRows) {
    //   return shelfRows.ShelfName != "";
    // })
    // const LoactionShelfobject = {};
    // LoactionShelfobject.ShelfXml = LoactionShelfdata;
    // let Shelfjsonstring = '';
    // Shelfjsonstring = JSON.stringify(LoactionShelfobject);
    // console.log("Shelfjsonstring==>>", Shelfjsonstring);
    // console.log("LoactionShelfobject==>>>", LoactionShelfobject);

    // //for Rack Json
    // let LoactionRackdata = rackRows.filter(function (rackRows) {
    //   return rackRows.RackName != "";
    // })
    // const LoactionRackobject = {};
    // LoactionRackobject.RackXml = LoactionRackdata;
    // let Rackjsonstring = '';
    // Rackjsonstring = JSON.stringify(LoactionRackobject);
    // console.log("Rackjsonstring==>>", Rackjsonstring);
    // console.log("LoactionRackobject==>>>", LoactionRackobject);

    console.log("selectedTimezone.label: ", selectedTimezone.label);
    let taxValues = [
      {
        TaxId: values.TaxId1,
        TaxName: values.TaxName1,
        TaxPercent: values.TaxPercent1,
        TaxCumulative: values.Cumulative,
      },
      {
        TaxId: values.TaxId2,
        TaxName: values.TaxName2,
        TaxPercent: values.TaxPercent2,
        TaxCumulative: values.Cumulative,
      },
      {
        TaxId: values.TaxId3,
        TaxName: values.TaxName3,
        TaxPercent: values.TaxPercent3,
        TaxCumulative: values.Cumulative,
      },
      {
        TaxId: values.TaxId4,
        TaxName: values.TaxName4,
        TaxPercent: values.TaxPercent4,
        TaxCumulative: values.Cumulative,
      },
      {
        TaxId: values.TaxId5,
        TaxName: values.TaxName5,
        TaxPercent: values.TaxPercent5,
        TaxCumulative: values.Cumulative,
      },
    ];

    console.log("xjsd", rowsData);

    let taxdata = taxValues.filter(function (rowData) {
      return rowData.TaxName != "";
    });

    let registerdata;
    if (
      selectCredit == 1 ||
      selectCredit == 4 ||
      selectCredit == 9 ||
      selectCredit == 10
    ) {
      registerdata = rowsData.filter(function (rowData) {
        return rowData.RegisterName != "";
      });
    } else if (
      selectCredit == 2 ||
      selectCredit == 5 ||
      selectCredit == 6 ||
      selectCredit == 7 ||
      selectCredit == 8 ||
      selectCredit == 11
    ) {
      registerdata = worldPay.filter(function (rowData) {
        return rowData.RegisterName != "";
      });
    } else {
      registerdata = cardConnect.filter(function (rowData) {
        return rowData.RegisterName != "";
      });
    }

    let RegisterValuesData = {};
    let taxValuesData = {};
    console.log("jh", RegisterValuesData);

    RegisterValuesData.locationsregistersXML = registerdata;
    taxValuesData.locationsTaxXML = taxdata;

    let registerjsonstring = JSON.stringify(RegisterValuesData);
    console.log("registerjsonstring", registerjsonstring);
    let taxjsonstring = JSON.stringify(taxValuesData);

    let LocationData = {
      xmllocationregister: registerjsonstring,
      xmllocationstax: taxjsonstring,
      id: paramObject.id || 0,
      locationid: 1,
      name: values.Name,
      companyname: values.CompanyName,
      color: values.Color,
      taxid: values.TaxID,
      companylogo: ImageUrl,
      deletelogo: values.Deletelogo,
      website: values.Website,
      phone: values.PhoneNumber,
      address: values.Address,
      fax: values.Fax,
      email: values.Email,
      ccemail: values.CCEmail,
      bccemail: values.BCCEmail,
      emailsalesemail: values.Allsalestoemail,
      emailreceivingsemail: values.Allreceivingemail,
      returnpolicy: values.ReturnPolicy,
      employeeid: selectedemployee.toString(),
      enablecreditcardprocessing: values.EnableCreditCard,
      creditcardprocessor: values.CreditCardProcessor,
      phppospaymentsmerchantid: values.PHPPOSPayments,
      disableamountconfirmationwhenprocessingcreditcard:
        values.DisableAmountConfirmation,
      phppospaymentsapiKey: values.PHPPOSPaymentsAPIKey,
      useintegratedEBT: values.UseIntegratedEBT,
      phppospaymentsbearertoken: values.PHPPOSBearerToken,
      phppospaymentssigningkey: values.PHPPOSSigningKey,
      promptforloyalty: values.PromptForLoyalty,
      promptforname: values.PromptForName,
      promptforemail: values.PromptForEmail,
      promptforphonenumber: values.PromptForPhone,
      termsandconditions: values.TermsConditions,
      askformissinginformationforexistingcustomers:
        values.AskForMissingInformation,
      preWorkorderauthorizationterms: values.PreworkorderAuthorizationTerms,
      postWorkorderterms: values.PostWorkOrderTerms,
      phppospaymentstestMode: values.Phppostestmode,
      emvmerchantidandterminalid: values.EMVmerchantid,
      comport: values.COMPort,
      listenerport: values.ListenerPort,
      integratedgiftcards: values.Integratedgiftcards,
      netepayserver: values.Netepayserver,
      emvdeviceoverride: values.emvdevice,
      nonemvdeviceoverride: values.nonemvdevice,
      hostedcheckoutmerchantid: values.Hostedcheckout,
      mercurygeneratedpassword: values.Mercurypassword,
      merchantid: values.merchantid,
      restusername: values.Restusername,
      restpassword: values.Restpassword,
      squarecurrencycode: values.Currencycode,
      squaremultipliertogettotalincents: values.Multipliercents,
      stripecurrencycode: values.StripeCurrencycode,
      stripesecretkey: values.Stripesecretkey,
      stripepublishablekey: values.Stripepublishablekey,
      braintreemerchantid: values.BraintreeMerchantid,
      braintreepublickey: values.Publickey,
      braintreeprivatekey: values.Privatekey,
      autoreportsemail: values.autoemail,
      disablemarkupmarkdown: values.disablemarkup,
      autoreportsemailtime: allowedToLoginEndTime.format("HH:mm"),
      autoreportsday: values.Daytoemailreport,
      receivestockalert: values.ReceiveStockAlerts,
      stockalertemail: values.Stockalertemail,
      stockalertsjustorderlevel: values.Reorderlevel,
      timezone: JSON.stringify(selectedTimezone), // selectedTimezone.label,
      mailchimpapikey: values.Mailchip,
      platformlyapikey: values.Platformapikey,
      platformlyprojectid: values.PlatformlyProjectId,
      twilioSid: values.TwilioSid,
      twiliotoken: values.TwilioToken,
      twiliosmsfromnumber: values.TwilioSms,
      sidekickapikey: values.SidekickAPIKey,
      sidekickautoreview: values.SidekickAutomatically,
      overridedefaulttax: values.OverrideDefaultTaxForSale,
      taxgroup: selectedTaxGroup.value,
      additionalappointmentnote: values.AdditionalAppointment,
      loginuserid: Id,
    };
    console.log("CreditCardProcessor", values.CreditCardProcessor);
    console.log(LocationData);

    setLoading(true);
    axios
      .post(`${config.locationBaseUrl}/locations/upsert`, LocationData, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
          navigate("/locations");
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError("Email" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  let Employe = [];
  useEffect(() => {
    // Binding Customer Fields
    axios
      .get(
        `${config.suppliersBaseUrl}/suppliers/suppliercustomgetall?id=${Id}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // Taking the the custom fields
        setCustomFields(res.data.ResponseData.customefield);
      })
      .catch((err) => {
        console.log("Error: ", err);
        setLoading(false);
      });

    if (paramObject.id > 0) {
      setLoading(true);

      axios
        .get(
          `${config.locationBaseUrl}/locations/findbyid?id=${paramObject.id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log("res.data", res.data);
          const LocationData = res.data.ResponseData.Locations;
          const LocationTaxes = res.data.ResponseData.LocationTaxes;
          const LocationsRegisters = res.data.ResponseData.LocationsRegisters;
          console.log("LocationTaxes", LocationData);

          setFormValues(res.data.ResponseData.Locations[0])

          console.log("::{{{++>>>>", res.data.ResponseData.LoactionAisle);
          console.log("::{{{++>>>>", res.data.ResponseData.LoactionRack);
          console.log("::{{{++>>>>", res.data.ResponseData.LoactionBin);
          console.log("::{{{++>>>>", res.data.ResponseData.LoactionShelf);

          // setShelfRows(res.data.ResponseData.LoactionShelf);
          // setRackRows(res.data.ResponseData.LoactionRack);
          // setBinRows(res.data.ResponseData.LoactionBin);
          // setAisleRows(res.data.ResponseData.LoactionAisle);
          // Bind items Data
          axios
            .get(`${config.employeesBaseUrl}/employees/usersdropdown`, {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            })
            .then((res) => {
              const employeeData = res.data.ResponseData;
              employeeData.map((u, i) => {
                Employe[i] = { label: u.Name, value: u.Id };
              });

              // for bind values
              if (LocationData[0].EmployeeId) {
                Employe.map((selectItems) => {
                  const splitSelectedlocation =
                    LocationData[0].EmployeeId.split(",");

                  // using map() to convert array of strings to numbers
                  var splitSelectedlocationnumbers = splitSelectedlocation.map(
                    function (str) {
                      return parseInt(str);
                    }
                  );

                  setselectedemployee(splitSelectedlocationnumbers);
                });
              }
            });

          setSelectTaxable(LocationData.Taxable === 1 ? true : false);
          setImageUrl(LocationData[0].Companylogo);
          setDisableCumulative(
            LocationTaxes[1]?.Cumulative === 1 ? true : false
          );

          if (LocationTaxes.length > 2) {
            setShowMore(true);
          }
          console.log("LocationsRegisters", LocationsRegisters);

          const data = {
            Name: LocationData[0].Name,
            CompanyName: LocationData[0].CompanyName,
            Color: LocationData[0].Color,
            TaxID: LocationData[0].Taxid,
            companylogo: LocationData[0].Companylogo,
            Deletelogo: LocationData[0].DeleteLogo == 1 ? true : false,
            Website: LocationData[0].Website,
            PhoneNumber: LocationData[0].Phone,
            Address: LocationData[0].Address,
            Fax: LocationData[0].Fax,
            Email: LocationData[0].Email,
            CCEmail: LocationData[0].CCemail,
            BCCEmail: LocationData[0].BCCemail,
            Allsalestoemail: LocationData[0].EmailSalesEmail,
            Allreceivingemail: LocationData[0].EmailReceivingsEmail,
            ReturnPolicy: LocationData[0].ReturnPolicy,
            Employees: LocationData[0].EmployeeId,
            EnableCreditCard:
              LocationData[0].EnableCreditCardProcessing == 1 ? true : false,
            CreditCardProcessor: LocationData[0].CreditCardProcessor,
            PHPPOSPayments: LocationData[0].PHPPOSPaymentsMerchantID,
            DisableAmountConfirmation:
              LocationData[0]
                .DisableAmountConfirmationWhenProcessingCreditCard == 1
                ? true
                : false,
            PHPPOSPaymentsAPIKey: LocationData[0].PHPPOSPaymentsAPIKey,
            UseIntegratedEBT:
              LocationData[0].UseIntegratedEBT == 1 ? true : false,
            PHPPOSBearerToken: LocationData[0].PHPPOSPaymentsBearerToken,
            PHPPOSSigningKey: LocationData[0].PHPPOSPaymentsSigningKey,
            PromptForLoyalty:
              LocationData[0].PromptForLoyalty == 1 ? true : false,
            PromptForName: LocationData[0].PromptForName == 1 ? true : false,
            PromptForEmail: LocationData[0].PromptForEmail == 1 ? true : false,
            PromptForPhone:
              LocationData[0].PromptForPhoneNumber == 1 ? true : false,
            TermsConditions: LocationData[0].TermsandConditions,
            AskForMissingInformation:
              LocationData[0].AskForMissingInformationForExistingCustomers == 1
                ? true
                : false,
            PreworkorderAuthorizationTerms:
              LocationData[0].PreWorkOrderAuthorizationTerms,
            PostWorkOrderTerms: LocationData[0].PostWorkOrderTerms,
            Phppostestmode:
              LocationData[0].PHPPOSPaymentsTestMode == 1 ? true : false,
            EMVmerchantid: LocationData[0].EMVMerchantIDandTerminalID,
            COMPort: LocationData[0].COMPort,
            ListenerPort: LocationData[0].ListenerPort,
            Integratedgiftcards:
              LocationData[0].IntegratedGiftCards == 1 ? true : false,
            Netepayserver: LocationData[0].NetEPayServer,
            emvdevice: LocationData[0].EMVDeviceOverride,
            nonemvdevice: LocationData[0].NonEMVDeviceOverride,
            Hostedcheckout: LocationData[0].HostedCheckoutMerchantID,
            Mercurypassword: LocationData[0].MercuryGeneratedPassword,
            merchantid: LocationData[0].MerchantID,
            Restusername: LocationData[0].RestUsername,
            Restpassword: LocationData[0].RestPassword,
            Currencycode: LocationData[0].SquareCurrencyCode,
            Multipliercents: LocationData[0].SquareMultiplierToGetTotalInCents,
            StripeCurrencycode: LocationData[0].StripeCurrencyCode,
            Stripesecretkey: LocationData[0].StripeSecretKey,
            Stripepublishablekey: LocationData[0].StripePublishableKey,
            BraintreeMerchantid: LocationData[0].BraintreeMerchantId,
            Publickey: LocationData[0].BraintreePublicKey,
            Privatekey: LocationData[0].BraintreePrivateKey,
            autoemail: LocationData[0].AutoReportsEmail,
            disablemarkup:
              LocationData[0].DisableMarkupMarkdown == 1 ? true : false,
            autoemailreportstime: LocationData[0].AutoReportsEmailTime,
            Daytoemailreport: LocationData[0].AutoReportsDay,
            ReceiveStockAlerts:
              LocationData[0].ReceiveStockAlert == 1 ? true : false,
            Stockalertemail: LocationData[0].StockAlertEmail,
            Reorderlevel:
              LocationData[0].StockAlertsJustOrderLevel == 1 ? true : false,
            Timezone: JSON.parse(LocationData[0].Timezone),
            Mailchip: LocationData[0].MailchimpApiKey,
            Platformapikey: LocationData[0].PlatformlyApiKey,
            PlatformlyProjectId: LocationData[0].PlatformlyProjectId,
            TwilioSid: LocationData[0].TwilioSId,
            TwilioToken: LocationData[0].TwilioToken,
            TwilioSms: LocationData[0].TwiliosmsFromNumber,
            SidekickAPIKey: LocationData[0].SidekickApiKey,
            SidekickAutomatically:
              LocationData[0].SidekickAutoReview == 1 ? true : false,
            // Terms: LocationData[0].TaxGroup,
            OverrideDefaultTaxForSale:
              LocationData[0].Overridedefaulttax === 1 ? true : false,
            TaxGroup: LocationData[0].TaxGroup,
            TaxId1: LocationTaxes[0]?.Id,
            TaxName1: LocationTaxes[0]?.Name,
            TaxPercent1: LocationTaxes[0]?.Percent,
            TaxId2: LocationTaxes[1]?.Id,
            TaxName2: LocationTaxes[1]?.Name,
            TaxPercent2: LocationTaxes[1]?.Percent,
            Cumulative: LocationTaxes[1]?.Cumulative == 1 ? true : false,
            TaxId3: LocationTaxes[2]?.Id,
            TaxName3: LocationTaxes[2]?.Name,
            TaxPercent3: LocationTaxes[2]?.Percent,
            TaxId4: LocationTaxes[3]?.Id,
            TaxName4: LocationTaxes[3]?.Name,
            TaxPercent4: LocationTaxes[3]?.Percent,
            TaxId5: LocationTaxes[4]?.Id,
            TaxName5: LocationTaxes[4]?.Name,
            TaxPercent5: LocationTaxes[4]?.Percent,
            AdditionalAppointment: LocationData[0].AdditionalAppointmentNote,
          };
          console.log("hello", data);

          setFormValues(data);
          setSelectedTimezone(JSON.parse(LocationData[0].Timezone));
          setLoading(false);
          // setTaxValue(LocationTaxes);
          // setSelectLocation(LocationsRegisters);

          console.log(
            "LocationData[0].CreditCardProcessor ==>",
            LocationData[0].CreditCardProcessor
          );
          setSelectOverrideDefaultTaxForSale(
            LocationData[0].Overridedefaulttax == 1 ? true : false
          );
          setSelectedTaxGroup(LocationTaxes);
          showRegisterColumns(parseInt(LocationData[0].CreditCardProcessor));
          setSelectReceivestock(
            LocationData[0].EnableCreditCardProcessing == 1 ? true : false
          );

          let creditCardProcessorValue = parseInt(
            LocationData[0].CreditCardProcessor
          );
          setSelectCredit(creditCardProcessorValue);
          console.log("hjf", creditCardProcessorValue);
          if (
            creditCardProcessorValue == 1 ||
            creditCardProcessorValue == 4 ||
            creditCardProcessorValue == 9 ||
            creditCardProcessorValue == 10
          ) {
            setRowsData(LocationsRegisters);
          } else if (
            creditCardProcessorValue === 2 ||
            creditCardProcessorValue == 5 ||
            creditCardProcessorValue == 6 ||
            creditCardProcessorValue == 7 ||
            creditCardProcessorValue == 8 ||
            creditCardProcessorValue == 11
          ) {
            setworldPay(LocationsRegisters);
          } else {
            setcardConnect(LocationsRegisters);
          }
        })

        .catch((err) => {
          setLoading(false);
        });
    }
  }, []);

  // let Employee = [];

  useEffect(() => {
    axios
      .get(`${config.locationBaseUrl}/locations/listofcreditcard`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedCreditcard(res.data.ResponseData);
        // setLoading(false);
        return res;
      });

    axios
      .get(`${config.employeesBaseUrl}/employees/usersdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setEmployeeData(res.data.ResponseData);
        // setLoading(false);
        return res;
      });

    // console.log("rowsData after splice 111 :", rowsData);
    // callback(rowsData);
  }, [rowsData, setRowsData]);

  const callback = (payload) => {
    console.log("payload =>", payload);
    // setRowsData(payload);

    // setSelectCredit(1);
    // setRowsData(payload);
  };
  // const divStyle = {
  //   height: "20px",
  // };

  return (
    <>
      <Sidebar />

      <Loader loading={loading} />

      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position" >
              {/* <h3 className="page-title">Locations</h3> */}
              <ul className="breadcrumb" style={{ marginLeft: "12px" }}>
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/locations">Locations List</Link>
                </li>
                <li className="breadcrumb-item active">Manage Locations</li>
              </ul>
            </div>
          </div>
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">Locations Information</h5>
            </div>
            <Formik
              {...props}
              initialValues={formValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({ values, errors, touched, handleChange, handleBlur }) => (
                <Form>
                  <div className="card-body">
                    <div className="row mb-2">
                      <div className="col-sm-6">
                        <div className="row">
                          <label className="col-form-label col-md-4 form-label">
                            Name<span className="text-danger">*</span>
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className={`form-control form-control-sm ${
                                errors.Name ? "is-invalid" : ""
                              }`}
                              onChange={handleChange}
                              id="Name"
                              name="Name"
                              // value={FormValue?.Name}
                            />
                            <div className="invalid-feedback">
                              {touched.Name && errors.Name ? errors.Name : ""}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label mb-3 col-md-4 form-label">
                            Company Name
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className="form-control form-control-sm"
                              onChange={handleChange}
                              id="CompanyName"
                              name="CompanyName"
                              // value={FormValue?.CompanyName}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="row">
                          <label className="col-form-label col-md-4">
                            Color
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="color"
                              name="Color"
                              className={`form-control form-control-sm form-control-color w-2`}
                              value={values.Color}
                              onBlur={handleBlur}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6 mb-2">
                        <div className=" row">
                          <label className="col-form-label col-md-4 form-label">
                            Tax ID
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className="form-control form-control-sm"
                              onChange={handleChange}
                              id="TaxID"
                              name="TaxID"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6 mb-2">
                        <div className=" row">
                          <label className="col-form-label col-md-4 form-label">
                            Company Logo
                          </label>
                          <div className="col-md-8">
                            <FileInput
                              id="companylogo"
                              name="companylogo"
                              value={selectedImage}
                              accept="image/*"
                              handleChange={_handleFileChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div
                            className={`${
                              ImageUrl ? "" : selectedImage ? "" : "d-none"
                            }  row`}
                          >
                            <label className="col-form-label col-md-4 form-label"></label>
                            <div className="col-sm">
                              <img
                                src={`${ImageUrl ? ImageUrl : selectedImage}`}
                                alt="Companylogo Image"
                                className="ImagePreviewSize"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className="col-sm-6">
                        <div className="row">
                          <label className="form-check-label col-md-4">
                            Delete logo
                          </label>
                          <div className="col-md-7 mb-3">
                            <Field
                              type="checkbox"
                              style={{ width: "1.25em", height: "1.25em" }}
                              className="form-check-input"
                              id="Deletelogo"
                              name="Deletelogo"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div> */}
                      <div className="col-sm-12 mb-2">
                        <div className=" row">
                          <label className="col-form-label col-md-2">
                            Delete logo
                          </label>
                          <div className="col-md-1">
                            <Field
                              type="checkbox"
                              style={{ width: "1.5em", height: "1.5em" }}
                              className="form-check-input"
                              id="Deletelogo"
                              name="Deletelogo"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-4 form-label mb-3">
                            Website
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className="form-control form-control-sm"
                              onChange={handleChange}
                              id="Website"
                              name="Website"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-4 form-label">
                            PhoneNumber
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="textarea"
                              className={`form-control form-control-sm ${
                                errors.PhoneNumber ? "is-invalid" : ""
                              }`}
                              onChange={handleChange}
                              id="PhoneNumber"
                              name="PhoneNumber"
                            />
                            <div className="invalid-feedback">
                              {touched.PhoneNumber && errors.PhoneNumber
                                ? errors.PhoneNumber
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="row"> */}
                      {/* <div className="col-sm-6">
                        <div
                          className={`${
                            ImageUrl ? "" : selectedImage ? "" : "d-none"
                          }  row`}
                        >
                          <label className="col-form-label col-md-2 form-label"></label>
                          <div className="col-md-10">
                            <img
                              src={`${ImageUrl ? ImageUrl : selectedImage}`}
                              alt="Category Image"
                              className="ImagePreviewSize"
                            />
                          </div>
                        </div> */}
                      {/* </div> */}
                    {/* </div> */}
                    <div className="row mb-2">
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-4 form-label mb-3">
                            Address <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className={`form-control form-control-sm ${
                                errors.Address ? "is-invalid" : ""
                              }`}
                              onChange={handleChange}
                              id="Address"
                              name="Address"
                              // value={FormValue.Address}
                            />
                            <div className="invalid-feedback">
                              {touched.Address && errors.Address
                                ? errors.Address
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-4 form-label">
                            Fax
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className="form-control form-control-sm"
                              onChange={handleChange}
                              id="Fax"
                              name="Fax"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-4 form-label mb-3">
                            Email
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="email"
                              className="form-control form-control-sm"
                              onChange={handleChange}
                              id="Email"
                              name="Email"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-4 form-label mb-3">
                            CC Email
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="email"
                              className="form-control form-control-sm"
                              onChange={handleChange}
                              id="CCEmail"
                              name="CCEmail"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-4 form-label mb-3">
                            BCC Email
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="email"
                              className="form-control form-control-sm"
                              onChange={handleChange}
                              id="BCCEmail"
                              name="BCCEmail"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-4 form-label">
                            E-Mail All Sales To E-Mail
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="email"
                              className="form-control form-control-sm"
                              onChange={handleChange}
                              id="Allsalestoemail"
                              name="Allsalestoemail"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-4 form-label">
                            E-Mail All Receivings To E-Mail
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="email"
                              className="form-control form-control-sm"
                              onChange={handleChange}
                              id="Allreceivingemail"
                              name="Allreceivingemail"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-4 form-label">
                            Return Policy
                          </label>
                          <div className="col-md-8">
                            <Field
                              as="textarea"
                              className="form-control form-control-sm"
                              Employees
                              onChange={handleChange}
                              id="ReturnPolicy "
                              name="ReturnPolicy"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-12 mb-3">
                      <div className=" row">
                        <label className="col-form-label  col-md-2 form-label">
                          Employees
                        </label>
                        <div className="col-md-5">
                          <Select
                            backspaceRemovesValue={false}
                            controlShouldRenderValue={true}
                            hideSelectedOptions={true}
                            isMulti={true}
                            isClearable={true}
                            onChange={handleEmployeeIds}
                            options={employeeOption}
                            placeholder=""
                            styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                            value={employeeOption.filter((obj) =>
                              selectedemployee.includes(obj.value)
                            )}
                            id="Employees"
                            name="Employees"
                            className="custom-search-select"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-12">
                        <div className=" row">
                          <label className="col-form-label col-md-2">
                            Registers
                          </label>
                          <div className="col-md-10">
                            <div className="table-responsive">
                              <table className="table">
                                <thead>
                                  <tr>
                                    {showColumns.RegisterName && (
                                      <th width="30%">Register Name</th>
                                    )}
                                    {showColumns.TerminalID && (
                                      <th width="30%">Terminal ID</th>
                                    )}
                                    {showColumns.EnableTips && (
                                      <th width="30%">Enable Tips</th>
                                    )}
                                    {showColumns.IPTranDeviceID && (
                                      <th width="30%">IP Tran Device ID</th>
                                    )}
                                    {showColumns.PinPadIP && (
                                      <th width="30%">Pin Pad IP</th>
                                    )}
                                    {showColumns.PinPadPort && (
                                      <th width="30%">Pin Pad Port</th>
                                    )}
                                    {showColumns.CardReaderActions && (
                                      <th width="30%">Card Reader Actions</th>
                                    )}
                                    {showColumns.CardConnectHSN && (
                                      <th width="30%">CardConnect HSN</th>
                                    )}

                                    {showColumns.Delete && (
                                      <th width="10%">Delete</th>
                                    )}
                                  </tr>
                                </thead>
                                <tbody>
                                  <LocationsTableRows
                                    callback={callback}
                                    // sendData={sendData}
                                    selectCredit={selectCredit}
                                    rowsData={
                                      (selectCredit === 1 ||
                                      selectCredit === 4 ||
                                      selectCredit === 9 ||
                                      selectCredit === 10)
                                        ? rowsData
                                        : ((selectCredit === 2 ||
                                          selectCredit === 5 ||
                                          selectCredit === 6 ||
                                          selectCredit === 7 ||
                                          selectCredit === 8 ||
                                          selectCredit === 11)
                                        ? worldPay
                                        : cardConnect)
                                    }
                                    deleteTableRows={(deleteIndex) =>
                                      selectCredit == 1 ||
                                      selectCredit == 4 ||
                                      selectCredit == 9 ||
                                      selectCredit == 10
                                        ? deleteTableRows(
                                            deleteIndex,
                                            setRowsData
                                          )
                                        : selectCredit == 2 ||
                                          selectCredit == 5 ||
                                          selectCredit == 6 ||
                                          selectCredit == 7 ||
                                          selectCredit == 8 ||
                                          selectCredit == 11
                                        ? deleteTableworldPay
                                        : deleteTablecardConnect
                                    }
                                    handleChange={
                                      selectCredit == 1 ||
                                      selectCredit == 4 ||
                                      selectCredit == 9 ||
                                      selectCredit == 10
                                        ? handleChangeTableRow
                                        : selectCredit == 2 ||
                                          selectCredit == 5 ||
                                          selectCredit == 6 ||
                                          selectCredit == 7 ||
                                          selectCredit == 8 ||
                                          selectCredit == 11
                                        ? handleChangeTableworldPay
                                        : handleChangeTablecardConnect
                                    }
                                  />
                                </tbody>
                              </table>
                            </div>
                            <button
                              type="button"
                              className="btn btn-secondary btn-sm pull-left mt-3 mb-3 ml-3"
                              onClick={
                                selectCredit === 1 ||
                                selectCredit === 4 ||
                                selectCredit === 9 ||
                                selectCredit === 10
                                  ? addTableRows
                                  : selectCredit === 2 ||
                                    selectCredit === 5 ||
                                    selectCredit === 6 ||
                                    selectCredit === 7 ||
                                    selectCredit === 8 ||
                                    selectCredit === 11
                                  ? addTableworldPay
                                  : addTablecardConnect
                              }
                            >
                              <i className="fa fa-plus fa-sm" /> Add
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-4 form-label">
                            Enable Credit Card Processing
                          </label>
                          <div className="col-md-1">
                            <Field
                              className="form-check-input"
                              style={{ width: "1.25em", height: "1.25em" }}
                              type="checkbox"
                              id="EnableCreditCard"
                              name="EnableCreditCard"
                              onChange={handleChange}
                              onInput={handleSelectEnableCreditCardProcess}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className={`${
                        selectCreditCard === true ? "" : "d-none"
                      }`}
                    >
                      <div className="row mb-2">
                        <div className="col-sm-6">
                          <div className=" row">
                            <label className="col-form-label col-md-4 form-label">
                              Credit Card Processor
                            </label>
                            <div className="col-md-8">
                              <Field
                                as="select"
                                className="form-control form-control-sm"
                                name="CreditCardProcessor"
                                id="CreditCardProcessor"
                                 value={selectCredit}
                                onInput={(event) => {
                                  handleDropdownChange(event);
                                  handleChange(event);
                                }}
                                onChange={handleChange}
                              >
                                <option value={""}>Select</option>
                                {selectedcreditcard.map((u) => (
                                  <option value={u.Id}> {u.Name} </option>
                                ))}
                              </Field>
                            </div>
                          </div>
                        </div>
                      </div>

                      <LocationField
                        showhidecomponent={selectCredit == 1 ? true : false}
                      />

                      <LocationWorldpay
                        showhidecomponent={
                          selectCredit == 2 ||
                          selectCredit == 5 ||
                          selectCredit == 6 ||
                          selectCredit == 7 ||
                          selectCredit == 8 ||
                          selectCredit == 11
                            ? true
                            : false
                        }
                      />

                      <LocationCardConnect
                        showhidecomponent={selectCredit == 3 ? true : false}
                      />

                      <LocationSquare
                        showhidecomponent={selectCredit == 4 ? true : false}
                      />

                      <LocationStripe
                        showhidecomponent={selectCredit == 9 ? true : false}
                      />

                      <LocationBraintree
                        showhidecomponent={selectCredit == 10 ? true : false}
                      />
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-4 form-label">
                            Auto E-Mail Reports Address
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className="form-control form-control-sm"
                              onChange={handleChange}
                              id="autoemail"
                              name="autoemail"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-4 form-label">
                            Disable Markup/Markdown
                          </label>
                          <div className="col-md-1">
                          <Field
                            type="checkbox"
                            style={{ width: "1.25em", height: "1.25em" }}
                            className="form-check-input"
                            onChange={handleChange}
                            id="disablemarkup"
                            name="disablemarkup"
                            />
                            </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-4 form-control-smf form-label">
                            Auto E-Mail Reports Time
                          </label>
                          <div className="col-md-8">
                            <div className="input-group">
                              <span
                                className="input-group-text"
                                id="basic-addon1"
                              >
                                <img src={Time} alt="img" />
                              </span>
                              <TimePicker
                                value={allowedToLoginEndTime}
                                onChange={onChangeAllowedToLoginEndTime}
                                showSecond={false}
                                style={{ width: "100%" }}
                                id="autoemailreportstime"
                                name="autoemailreportstime"
                                format="HH:mm"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-4 form-label">
                            Day To Email Report For
                          </label>
                          <div className="col-md-8">
                            <Field
                              as="select"
                              className="form-control form-control-sm"
                              name="Daytoemailreport"
                              id="Daytoemailreport"
                            >
                              <option value="Currentday">Currentday</option>
                              <option value="Previousday">Previousday</option>
                            </Field>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-4 form-label">
                            Receive Stock Alerts
                          </label>
                          <div className="col-md-1">
                            <Field
                              className="form-check-input"
                              style={{ width: "1.5em", height: "1.5em" }}
                              type="checkbox"
                              id=" ReceiveStockAlerts"
                              name="ReceiveStockAlerts"
                              onChange={handleChange}
                              onInput={handleSelectReceiveStocksalerts}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className={`${
                        selectReceivestock === true ? "" : "d-none"
                      }`}
                    >
                      <div className="row">
                        <div className="col-sm-6">
                          <div className=" row">
                            <label className="col-form-label col-md-4 form-label">
                              Stock Alert Email
                            </label>
                            <div className="col-md-8">
                              <Field
                                type="text"
                                className="form-control form-control-sm"
                                onChange={handleChange}
                                id="Stockalertemail"
                                name="Stockalertemail"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className=" row">
                            <label className="col-form-label col-md-4 form-label">
                              Alert Only For Items With Re-Order Level
                            </label>
                              <div className="col-md-1">
                                <Field
                                  type="checkbox"
                                  style={{ width: "1.5em", height: "1.5em" }}
                                  className="form-check-input"
                                  onChange={handleChange}
                                  id="Reorderlevel"
                                  name="Reorderlevel"
                                  />
                              </div> 
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mb-2">
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-4 form-label">
                            Timezone
                          </label>
                          <div className="col-md-8">
                            {/* <TimezoneSelect
                              value={selectedTimezone}
                              onChange={setSelectedTimezone}
                            /> */}

                            <TimezoneSelect
                              value={selectedTimezone}
                              onChange={setSelectedTimezone}
                              // style={divStyle}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-4 form-label">
                            <Link
                              className="p-14"
                              to={`https://mailchimp.com`}
                              target="_blank"
                            >
                              Mailchimp API Key
                            </Link>
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className="form-control form-control-sm"
                              onChange={handleChange}
                              id="Mailchip"
                              name="Mailchip"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-4 form-label">
                            <Link
                              className="p-14"
                              to={`https://www.platformly.com`}
                              target="_blank"
                            >
                              Platform.Ly API Key
                            </Link>
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className="form-control form-control-sm"
                              onChange={handleChange}
                              id="Platformapikey"
                              name="Platformapikey"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-4 form-label">
                            <Link
                              className="p-14"
                              to={`https://www.platformly.com`}
                              target="_blank"
                            >
                              Platformly Project ID
                            </Link>
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className="form-control form-control-sm"
                              onChange={handleChange}
                              id="PlatformlyProjectId"
                              name="PlatformlyProjectId"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label mb-3 col-md-4 form-label">
                            <Link
                              className="p-14"
                              to={`https://www.twilio.com`}
                              target="_blank"
                            >
                              Twilio SID
                            </Link>
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className="form-control form-control-sm"
                              onChange={handleChange}
                              id="TwilioSid"
                              name="TwilioSid"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label mb-3 col-md-4 form-label">
                            <Link
                              className="p-14"
                              to={`https://www.twilio.com`}
                              target="_blank"
                            >
                              Twilio Token
                            </Link>
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className="form-control form-control-sm"
                              onChange={handleChange}
                              id="TwilioToken"
                              name="TwilioToken"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-4 form-label">
                            <Link
                              className="p-14"
                              to={`https://www.twilio.com`}
                              target="_blank"
                            >
                              Twilio SMS From Number
                            </Link>
                          </label>
                          <div className="col-md-8">
                            <Field
                              type="text"
                              className="form-control form-control-sm"
                              onChange={handleChange}
                              id="TwilioSms"
                              name="TwilioSms"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className=" row">
                          <label className="col-form-label col-md-4 form-label">
                            Sidekick API Key
                          </label>
                          <div className="col-md-8">
                            <Field
                              as="textarea"
                              className="form-control form-control-sm"
                              onChange={handleChange}
                              id="SidekickAPIKey "
                              name="SidekickAPIKey"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <div className="row">
                        <label className="col-form-label col-md-3 form-label">
                          Sidekick Automatically Ask For Reviews After Sale
                        </label>
                        <div className="col-md-1">
                        <Field
                          type="checkbox"
                          style={{ width: "1.5em", height: "1.5em" }}
                          className="form-check-input"
                          onChange={handleChange}
                          id="SidekickAutomatically"
                          name="SidekickAutomatically"
                        />
                        </div>
                      </div>
                    </div>

                    <div className="row mb-12">
                      <div className="col-sm-12">
                        <div className=" row">
                          <label className="col-form-label col-md-3 form-label">
                            Override Default Tax For Sale
                          </label>
                          <div className="col-md-1">
                            <Field
                              className="form-check-input"
                              style={{ width: "1.5em", height: "1.5em" }}
                              type="checkbox"
                              id="OverrideDefaultTaxForSale"
                              name="OverrideDefaultTaxForSale"
                              onChange={handleChange}
                              onInput={handleSelectOverrideDefaultTaxForSale}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className={`${
                        selectOverrideDefaultTaxForSale === true ? "" : "d-none"
                      }`}
                    >
                      <div className="row">
                        <div className="col-sm-12">
                          <div className=" row">
                            <label className="col-form-label col-md-3 form-label">
                              Tax Group
                            </label>
                            <div className="col-md-8">
                              <Select
                                backspaceRemovesValue={false}
                                controlShouldRenderValue={true}
                                hideSelectedOptions={true}
                                isClearable={true}
                                onChange={setSelectedTaxGroup}
                                options={terms}
                                placeholder=""
                                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                value={selectedTaxGroup}
                                id="TaxGroup"
                                name="TaxGroup"
                                className="custom-search-select"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="">
                            <h4 className="text-center p-20 bold">OR</h4>
                          </div>
                        </div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-sm-12">
                          <div className=" row">
                            <label className="col-form-label col-md-3 form-label">
                              Tax 1
                            </label>
                            <div className="col-md-4">
                              <Field type="hidden" name="TaxId1" />
                              <Field
                                type="text"
                                className="form-control form-control-sm"
                                onChange={handleChange}
                                id="TaxName1"
                                name="TaxName1"
                                placeholder="Tax Name"
                              />
                            </div>
                            <div className="col-md-4">
                              <Field
                                type="text"
                                className={`form-control form-control-sm ${
                                  errors.TaxPercent1 ? "is-invalid" : ""
                                }`}
                                onChange={handleChange}
                                id="TaxPercent1"
                                name="TaxPercent1"
                                placeholder="Tax Percent"
                              />
                              <div className="invalid-feedback">
                                {touched.TaxPercent1 && errors.TaxPercent1
                                  ? errors.TaxPercent1
                                  : ""}
                              </div>
                            </div>
                            {/* <div className="col-md-1">
                                                            <span>%</span>
                                                        </div> */}
                          </div>
                        </div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-sm-12">
                          <div className=" row">
                            <label className="col-form-label col-md-3 form-label">
                              Tax 2
                            </label>
                            <div className="col-md-4">
                              <Field type="hidden" name="TaxId2" />
                              <Field
                                type="text"
                                className="form-control form-control-sm"
                                onChange={handleChange}
                                id="TaxName2"
                                name="TaxName2"
                                placeholder="Tax Name"
                              />
                            </div>
                            <div className="col-md-4">
                              <Field
                                type="text"
                                className={`form-control form-control-sm ${
                                  errors.TaxPercent2 ? "is-invalid" : ""
                                }`}
                                onChange={handleChange}
                                id="TaxPercent2"
                                name="TaxPercent2"
                                placeholder="Tax Percent"
                              />
                              <div className="invalid-feedback">
                                {touched.TaxPercent2 && errors.TaxPercent2
                                  ? errors.TaxPercent2
                                  : ""}
                              </div>
                            </div>
                            <div className="col-md-3">
                              {/* <span>%</span> */}
                              <Field
                                className="form-check-input"
                                style={{ width: "1.5em", height: "1.5em" }}
                                type="checkbox"
                                id="Cumulative"
                                name="Cumulative"
                                onChange={handleChange}
                                disabled={disableCumulative}
                              />
                              <span className="col-form-label"> Cumulative</span>
                            </div>
                            <div
                              className={`col-form-label col-md-2 form-label mt-3 ${
                                showMore === false ? "" : "d-none"
                              }`}
                            >
                              <Link onClick={handleShowMore}>Show More</Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={`${showMore === true ? "mb-2" : "d-none mb-2"}`}>
                        <div className="row mb-2">
                          <div className="col-sm-12">
                            <div className=" row">
                              <label className="col-form-label col-md-3 form-label">
                                Tax 3
                              </label>
                              <div className="col-md-4">
                                <Field type="hidden" name="TaxId3" />
                                <Field
                                  type="text"
                                  className="form-control"
                                  onChange={handleChange}
                                  id="TaxName3"
                                  name="TaxName3"
                                  placeholder="Tax Name"
                                />
                              </div>
                              <div className="col-md-4">
                                <Field
                                  type="text"
                                  className={`form-control form-control-sm ${
                                    errors.TaxName3 ? "is-invalid" : ""
                                  }`}
                                  onChange={handleChange}
                                  id="TaxPercent3"
                                  name="TaxPercent3"
                                  placeholder="Tax Percent"
                                />
                                <div className="invalid-feedback">
                                  {touched.TaxName3 && errors.TaxName3
                                    ? errors.TaxName3
                                    : ""}
                                </div>
                                {/* <span>%</span> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-sm-12">
                            <div className=" row">
                              <label className="col-form-label col-md-3 form-label">
                                Tax 4
                              </label>
                              <div className="col-md-4">
                                <Field type="hidden" name="TaxId4" />
                                <Field
                                  type="text"
                                  className="form-control form-control-sm"
                                  onChange={handleChange}
                                  id="TaxName4"
                                  name="TaxName4"
                                  placeholder="Tax Name"
                                />
                              </div>
                              <div className="col-md-4">
                                <Field
                                  type="text"
                                  className={`form-control ${
                                    errors.TaxName4 ? "is-invalid" : ""
                                  }`}
                                  onChange={handleChange}
                                  id="TaxPercent4"
                                  name="TaxPercent4"
                                  placeholder="Tax Percent"
                                />
                                <div className="invalid-feedback">
                                  {touched.TaxName4 && errors.TaxName4
                                    ? errors.TaxName4
                                    : ""}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-sm-12">
                            <div className=" row">
                              <label className="col-form-label col-md-3 form-label">
                                Tax 5
                              </label>
                              <div className="col-md-4">
                                <Field type="hidden" name="TaxId5" />
                                <Field
                                  type="text"
                                  className="form-control form-control-sm"
                                  onChange={handleChange}
                                  id="TaxName5"
                                  name="TaxName5"
                                  placeholder="Tax Name"
                                />
                              </div>
                              <div className="col-md-4">
                                <Field
                                  type="text"
                                  className={`form-control form-control-sm ${
                                    errors.TaxName5 ? "is-invalid" : ""
                                  }`}
                                  onChange={handleChange}
                                  id="TaxPercent5"
                                  name="TaxPercent5"
                                  placeholder="Tax Percent"
                                />
                                <div className="invalid-feedback">
                                  {touched.TaxName5 && errors.TaxName5
                                    ? errors.TaxName5
                                    : ""}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-12 mt-4">
                      <div className="form-group row">
                        <label className="col-form-label col-md-3 form-label">
                          Additional Appointment Note
                        </label>
                        <div className="col-md-8">
                          <Field
                            as="textarea"
                            className="form-control form-control-sm"
                            onChange={handleChange}
                            id="AdditionalAppointment "
                            name="AdditionalAppointment"
                          />
                        </div>
                      </div>
                    </div>

                    {/* <div className="row"> */}

                    {/* Aisle */}
                    {/* <div className="col-md-6">
                        <div className="row">
                          <label className="col-form-label col-md-1 form-label">
                            Aisle
                          </label>
                          <div className="col-md-11">
                            <div className="table-responsive">
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th>Name</th>
                                    <th>Delete</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <AilseRow
                                    rowsData={aisleRows}
                                    deleteTableRows={deleteAisle}
                                    handleChange={handleChangeAisleRow}
                                  />
                                </tbody>
                              </table>
                            </div>
                            <div className="mt-3">
                              <button
                                type="button"
                                className="btn btn-outline-dark"
                                onClick={addAislerows}
                              >
                                <IoMdAddCircle />
                                Add
                              </button>
                            </div>
                          </div>
                        </div>
                      </div> */}

                    {/* Rack */}
                    {/* <div className="col-md-6">
                        <div className="row">
                          <label className="col-form-label col-md-1 form-label">
                            Rack
                          </label>
                          <div className="col-md-11">
                            <div className="table-responsive">
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th>Name</th>
                                    <th>Delete</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <RackRow
                                    rowsData={rackRows}
                                    deleteTableRows={deleteRack}
                                    handleChange={handleChangeRackRow}
                                  />
                                </tbody>
                              </table>
                            </div>
                            <div className="mt-3">
                              <button
                                type="button"
                                className="btn btn-outline-dark"
                                onClick={addRackerows}
                              >
                                <IoMdAddCircle />
                                Add
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}

                    {/* <div className="row mt-3"> */}

                    {/* Bin */}
                    {/* <div className="col-md-6">
                        <div className="row">
                          <label className="col-form-label col-md-1 form-label">
                            Bin
                          </label>
                          <div className="col-md-11">
                            <div className="table-responsive">
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th>Name</th>
                                    <th>Delete</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <BinRow
                                    rowsData={binRows}
                                    deleteTableRows={deleteBin}
                                    handleChange={handleChangeBinRow}
                                  />
                                </tbody>
                              </table>
                            </div>
                            <div className="mt-3">
                              <button
                                type="button"
                                className="btn btn-outline-dark"
                                onClick={addBinrows}
                              >
                                <IoMdAddCircle />
                                Add
                              </button>
                            </div>
                          </div>
                        </div>
                      </div> */}

                    {/* Shelf */}
                    {/* <div className="col-md-6">
                        <div className="row">
                          <label className="col-form-label col-md-1 form-label">
                            Shelf
                          </label>
                          <div className="col-md-11">
                            <div className="table-responsive">
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th>Name</th>
                                    <th>Delete</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <ShelfRow
                                    rowsData={shelfRows}
                                    deleteTableRows={deleteShelf}
                                    handleChange={handleChangeShelfRow}
                                  />
                                </tbody>
                              </table>
                            </div>
                            <div className="mt-3">
                              <button
                                type="button"
                                className="btn btn-outline-dark"
                                onClick={addShelfrows}
                              >
                                <IoMdAddCircle />
                                Add
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                    {/* </div> */}

                    <button
                      type="submit"
                      className="btn btn-sm btn-primary pull-right mb-3"
                      onClick={showValue}
                    >
                      Save
                    </button>
                    <Link
                      to="/locations"
                      className="btn btn-sm btn-dark btn-md me-1 pull-right"
                    >
                      Cancel
                    </Link>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageLocations;
